<template lang="pug">
div
  Header(current="insurances")
  .c-progress-form(@click="computePercentage")
    .row
      .column
        ProgressForm
          Family
          Vehicle(v-for="i in numberOfCars" :key="computeKey('car', i)" risk="car" :id="i")
          Vehicle(v-for="i in numberOfVans" :key="computeKey('van', i)" risk="van" :id="i")
          Vehicle(v-for="i in numberOfMotorbikes" :key="computeKey('motorbike', i)" risk="motorbike" :id="i")
          House(v-if="shouldInsureHouse")
          HouseRental(v-else)
          Personal
          Travel(v-if="shouldInsureTravel")
          Pension
          Independent(v-if="shouldInsureIndependent")
          DigitalBag(v-if="shouldInsureDigitalBag")
    ProgressBar(next="results" back="profiles" :percent="percentage")
</template>

<script>
import Header from './shared/Header'
import Family from './insurances/Family'
import House from './insurances/House'
import HouseRental from './insurances/HouseRental'
import Personal from './insurances/Personal'
import Travel from './insurances/Travel'
import Pension from './insurances/Pension'
import Independent from './insurances/Independent'
import DigitalBag from './insurances/DigitalBag'
import Vehicle from './insurances/Vehicle'
import ProgressBar from './shared/ProgressBar'
import ProgressForm from './shared/ProgressForm'

export default {
  data () {
    return {
      percentage: 0
    }
  },
  mounted () {
    const buttons = this.$el.querySelectorAll('.c-multiple-choice')
    for (let i = 0; i < buttons.length; i++) {
      let thisButton = buttons[i]
      let nextButton = buttons[i + 1]
      if (nextButton !== undefined) {
        thisButton.addEventListener('click', () => {
          nextButton.scrollIntoView({behavior: 'smooth'})
        })
      }
    }
    this.computePercentage()
  },
  beforeDestroy () {
    const buttons = this.$el.querySelectorAll('.c-multiple-choice')
    for (let i = 0; i < buttons.length; i++) {
      let thisButton = buttons[i]
      let nextButton = buttons[i + 1]
      if (nextButton !== undefined) {
        thisButton.removeEventListener('click', () => {
          nextButton.scrollIntoView({behavior: 'smooth'})
        })
      }
    }
  },
  components: {
    Header,
    ProgressBar,
    ProgressForm,
    Family,
    House,
    HouseRental,
    Personal,
    Travel,
    Pension,
    Independent,
    DigitalBag,
    Vehicle
  },
  created () {
    document.title = 'Seraphin - Check-up - Assurances'
  },
  computed: {
    numberOfCars () {
      return this.$store.state.person.number_of_cars
    },
    numberOfVans () {
      return this.$store.state.person.number_of_vans
    },
    numberOfMotorbikes () {
      return this.$store.state.person.number_of_motorbikes
    },
    shouldInsureHouse () {
      return this.$store.state.person.house_owner
    },
    shouldInsureTravel () {
      return this.$store.state.person.often_traveling_abroad
    },
    shouldInsureIndependent () {
      return this.$store.getters.isIndependent
    },
    shouldInsureDigitalBag () {
      return this.$store.state.person.has_digital_devices
    }
  },
  methods: {
    computeKey (risk, id) {
      return `${risk}_${id}`
    },
    computePercentage () {
      this.percentage = (this.$el.querySelectorAll('input:checked').length / this.$el.querySelectorAll('.c-progress-form__element').length) * 100
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Insurances.vue